import React, { useState, useEffect } from "react";
import "./TabPanel.css";
import ToolBar from "../../../screens/Social/SocialOperator/ToolBar";
import { AddCircle, Delete, Edit, RemoveCircle } from "@mui/icons-material";
import { IconButton } from "@mui/material";

function TabPanel({
  tabs,
  onTabChange,
  onPurgeAllClick,
  toolbarprops,
  showPurgeAll = false,
  addTab = false,
  onAddTabClick = () => {},
  activeTabIndex = 0,
  onEditTabClick,
  onDeleteTabClick,
}) {
  const [activeTab, setActiveTab] = useState(activeTabIndex);

  useEffect(() => {
    setActiveTab(activeTabIndex);
  }, [activeTabIndex]);
  useEffect(() => {
    onTabChange(activeTab);
  }, [activeTab]);
  const handleSelectivePurge = () => {
    onPurgeAllClick(true);
  };
  const getEditDeleteButtons = (tab) => {
    return onDeleteTabClick && tabs.length > 1 ? (
      <IconButton
        className="so-tab-edit-button"
        title="Delete Tab"
        aria-label="Delete Tab"
        onClick={() => onDeleteTabClick(tab)}
      >
        <RemoveCircle fontSize="24px" />
      </IconButton>
    ) : null;
  };
  return (
    <div className="panel">
      <div className="tabs">
        {tabs.map((tab, index) => (
          <>
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              onDoubleClick={() => {
                if (onEditTabClick) {
                  onEditTabClick(tab);
                }
              }}
              title="Double Click to Edit Tab Name"
              className={`tab-button ${activeTab === index ? "active" : ""}`}
            >
              {tab.icon}
              {tab.label}
              {getEditDeleteButtons(tab)}
            </button>
          </>
        ))}
        {addTab && (
          <button
            title="Add Tab"
            className="tab-button add-tab-button"
            onClick={onAddTabClick}
          >
            <AddCircle className="w-5 h-5" />
          </button>
        )}
        {showPurgeAll && (
          <div className="tabs-action-buttons">
            <button
              className="tab-button purge-button so-purge-button"
              onClick={() => {
                onPurgeAllClick();
              }}
            >
              <Delete className="w-5 h-5" />
              Purge All Media
            </button>
          </div>
        )}
      </div>

      <div className="tp-content">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`tab-content ${activeTab === index ? "active" : ""}`}
          >
            {toolbarprops && (
              <ToolBar
                {...toolbarprops}
                activeTabId={tabs[activeTab]?.id || 1}
                label={tab.label}
                handlePurge={handleSelectivePurge}
              />
            )}
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TabPanel;
